export const MobileTypeDecorator = {
  url() {
    return `signup-hubspot/mobile`;
  },
  query() {
    return {};
  }
};